import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Heading } from "style/components/Heading.styles";
import { Modal } from "components/Modal";
import { Button } from "components/Button";
import { trackEvent } from "utils/tracking";
import {
  RequestFeatureTypeForm,
  ContactUs,
  FAQ,
} from "features/HelpCenter/v2/Components";
import { SupportContainer } from "./Support.styles";
import { RocketJetIcon, HeadphoneIcon } from "assets/icons";

const Support = () => {
  const [showRequestFeatureModal, setShowRequestFeatureModal] = useState(false);
  const [showContactUsModal, setShowContactUsModal] = useState(false);

  const handleRequestFeatureClose = () => {
    setShowRequestFeatureModal(false);
  };

  const handleContactUsClose = () => {
    setShowContactUsModal(false);
  };

  return (
    <>
      <SupportContainer>
        <Heading className="support-heading">How can I get support?</Heading>

        <Row className="support-cards">
          <Col md={6} sm={12}>
            <div className="support-card">
              <div className="icon-wrapper">
                <RocketJetIcon />
              </div>
              <h3>Request a feature</h3>
              <p>
                What features are important to you, what would you like to see
                next?
              </p>
              <Button
                size="small"
                variant="outline"
                onClick={() => {
                  trackEvent({
                    name: "submit_feedback",
                    label: "Support",
                  });
                  setShowRequestFeatureModal(true);
                }}
              >
                Request now
              </Button>
            </div>
          </Col>

          <Col md={6} sm={12}>
            <div className="support-card">
              <div className="icon-wrapper">
                <HeadphoneIcon />
              </div>
              <h3>Contact us</h3>
              <p>
                Can&apos;t find what you&apos;re looking for? Talk to our
                customer support team.
              </p>
              <Button
                size="small"
                variant="outline"
                onClick={() => {
                  trackEvent({
                    name: "contact_support",
                    label: "Support",
                  });
                  setShowContactUsModal(true);
                }}
              >
                Contact now
              </Button>
            </div>
          </Col>
        </Row>
      </SupportContainer>

      {/* Request Feature Modal */}
      <Modal
        show={showRequestFeatureModal}
        onHide={handleRequestFeatureClose}
        size="lg"
        showClose={false}
      >
        <RequestFeatureTypeForm handleMenuClose={handleRequestFeatureClose} />
      </Modal>

      {/* Contact Us Modal */}
      <Modal
        show={showContactUsModal}
        onHide={handleContactUsClose}
        size="lg"
        showClose={false}
      >
        <ContactUs handleMenuClose={handleContactUsClose} />
      </Modal>
      <FAQ />
    </>
  );
};

export { Support };
